import apiClient from './apiClient';

const anuncioSistemaService = {
    obtenerPendiente: async () => {
        const response = await apiClient.get('/anuncios/pendiente');
        return response.status === 204 ? null : response.data;
    },

    marcarVisto: () => apiClient.post('/anuncios/marcar-visto'),
};

export default anuncioSistemaService;
